export default __webpack_public_path__ + "static/media/nmig_email.963900e2.svg";